import { Dispatch, Action } from 'redux';
import { addFigure } from '../drawing/actions/DrawingAction';
import { ShapeKind } from '../drawing/types';
import { moveToPage } from '../actions/PageAction';
import { defaultLineCaps } from '../drawing/reducers/drawingTool';

export interface ObjectDrawingTestParams {
  dispatch: Dispatch<Action>;
  numOfPages: number;
  count: number;
}

const objectDrawingTest = (params: ObjectDrawingTestParams) => {
  const { dispatch, numOfPages, count } = params;

  const r = () => Math.floor(Math.random() * 256);
  const rndColor = () => `rgb(${r()}, ${r()}, ${r()})`;
  const rnd = (n: number) => Math.floor(Math.random() * n);

  (async () => {
    for (let i = 0; i < numOfPages; i += 2) {
      moveToPage(0, i, dispatch);
      await new Promise(resolve => requestAnimationFrame(resolve));

      for (let j = 0; j < count; j += 1) {
        const kind = () => {
          switch (Math.floor(Math.random() * 6)) {
            case 0:
              return ShapeKind.Rect;
            case 1:
              return ShapeKind.Square;
            case 2:
              return ShapeKind.Oval;
            case 3:
              return ShapeKind.Circle;
            case 4:
              return ShapeKind.Triangle;
            case 5:
              return ShapeKind.EquilateralTriangle;
            default:
              throw new Error('Unexpected kind.');
          }
        };

        const width = rnd(1014) + 10;
        const height = rnd(1014) + 10;

        dispatch(addFigure(
          kind(),
          rnd(1696) - (width / 2),
          rnd(1200) - (height / 2),
          width,
          height,
          rndColor(),
          rndColor(),
          rnd(30),
          rnd(3),
          defaultLineCaps,
          0.5,
          (rnd(2) < 1),
        ));
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
    }
  })();
};

export default objectDrawingTest;
